<div class="page-container" [class.paddingLeft]="isSidebarExpanded">
    <div class="dashboard-wrapper">
        <div class="dashboard-cards-row">
            <div class="report-card animate-slide-up">
                <div class="content">
                    <p class="greeting fs-17 fw-500">Hey {{userName}},</p>
                    <p class="message fs-13 fw-500">Your dashboard’s all set—let’s get things done!</p>
                </div>
                <div class="illustration">
                    <img src="../../../../../assets/images/undraw_data-reports_l2u3 (1).svg"
                        alt="Data reports illustration" />
                </div>
            </div>

            <div class="dashboard-top-row">
                <div class="tick-tack-section">
                    <div class="tick-tack-heading">Choose a Role to See Stacks / Overall Dashboard</div>
                    <div class="tick-tack-cards-container">
                        <div class="tick-tack-card card-purple animate-slide-down"
                            [class.selected]="selectedRole === 'INSURER'" (click)="selectRole(enumRole.INSURER)">
                            <div class="tick-tack-title">INSURER</div>
                            <div class="tick-tack-avatars">
                                <img src="assets/images/avatar.svg" alt="Insurer" />
                                <img src="assets/images/avatar-female.svg" alt="Insurer" />
                            </div>
                        </div>
                        <div class="tick-tack-card card-pink animate-slide-up"
                            [class.selected]="selectedRole === 'PROVIDER'" (click)="selectRole(enumRole.PROVIDER)">
                            <div class="tick-tack-title">PROVIDER</div>
                            <div class="tick-tack-avatars">
                                <img src="assets/images/avatar-female.svg" alt="Provider" />
                                <img src="assets/images/avatar-female.svg" alt="Provider" />
                                <img src="assets/images/avatar.svg" alt="Insurer" />

                            </div>
                        </div>
                        <div class="tick-tack-card card-green animate-slide-down"
                            [class.selected]="selectedRole === 'DISTRIBUTOR'"
                            (click)="selectRole(enumRole.DISTRIBUTOR)">
                            <div class="tick-tack-title">DISTRIBUTOR</div>
                            <div class="tick-tack-avatars">
                                <img src="assets/images/avatar-female.svg" alt="Distributor" />
                                <img src="assets/images/avatar.svg" alt="Distributor" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    @if(dataLoading){
    <div class="d-flex justify-content-center align-items-center custom-card">
        <div class="loader-pro">
            <app-loader></app-loader>
        </div>
    </div>
    }
    @else {
    <div class="cards-display-container">
        <section class="card-item border-top-right-radius">
            <div class="card-item border-top-right-radius animate-slide-right">
                <!-- Org selection code -->
                <div class="section-header">
                    <p class="fs-16">{{selectedRole | lowercase | titlecase}} Organisations</p>
                </div>
                <div class="arrow-icon-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"
                        class="arrow-icon" (click)="onArrowClick()">
                        <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-linejoin="round"
                            d="m19 12l-7-7l-7 7m7-7v14" stroke-width="1" />
                    </svg>
                </div>
                <div class="user-selector-container">
                    <!-- <p>Choose Insurer Admin</p> -->
                    <div class="w-100">
                        <mat-form-field appearance="outline" class="search-field-agent">
                            <span matPrefix style="display: flex; align-items: center; margin-left: 8px;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                    fill="none" stroke="#0075C9" stroke-width="1.2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314" />
                                </svg>
                            </span>
                            <input matInput placeholder="Search by organisation name" (click)="$event.stopPropagation()"
                                [(ngModel)]="searchInsurer" (ngModelChange)="onSearchInsurer()" />
                        </mat-form-field>
                    </div>
                    <div class="user-carousel-wrapper">
                        <button class="nav-button prev-button" (click)="prevInsurerCard()"
                            [disabled]="!canGoPrevInsurer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-left">
                                <polyline points="15 18 9 12 15 6"></polyline>
                            </svg>
                        </button>
                        <div class="user-carousel-view">
                            <div class="user-cards-grid" [style.transform]="carouselTransform">
                                @if(orgList.length > 0){

                                <div *ngFor="let org of orgList;let i=index" class="user-card"
                                    [class.selected]="selectedInsurerId === org.orgId" (click)="selectInsurer(org)"
                                    [@userCardAnimation]="selectedInsurerId === org.orgId ? 'selected' : 'unselected'"
                                    [style.margin-left.px]="i === 0 ? 8 : null">
                                    <div class="card-content-wrapper">
                                        <div class="user-avatar">
                                            {{ org.tradingName | initials}}
                                        </div>
                                        <div class="user-info-text">
                                            <p class="fs-12" style="margin: 0;">{{ org.tradingName }}
                                            </p>
                                            <div class="fs-12"
                                                [ngClass]="org.isactive ? 'active-text' : 'inactive-text'">
                                                {{ org.isactive ? 'Active' : 'Deactivated' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                }
                                @else {
                                <div class="card-content-wrapper mt-2">
                                    <div class="d-flex justify-content-center align-items-center h-100 w-100">
                                        No matches found.
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                        <button class="nav-button next-button" (click)="nextInsurerCard()"
                            [disabled]="!canGoNextInsurer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-right">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </button>
                    </div>
                </div>
                <!-- Stats and Graph Row -->
                <div class="insurer-stats-row">
                    <!-- Left 40%: Cards and Chart -->
                    <div class="insurer-stats-left">

                        <div class="mt-2"><span class="gray-text">Organisation Selected :</span>
                            {{getSelectedOrganisationName()}}</div>

                        <!-- Two small cards row -->
                        <div class="mini-cards-row">
                            <!-- ADMIN_INSURER Card -->
                            <div class="mini-card admin-insurer-card animate-slide-down">
                                <div>
                                    <div class="mini-card-label">ADMIN {{selectedRole}}</div>
                                    <div class="mini-card-count">
                                        {{ totalRolesCount?.['ADMIN_' + selectedRole] || 0 }}
                                    </div>
                                </div>
                                <div class="mini-card-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 36 36">
                                        <path fill="#66aee06e"
                                            d="M14.68 14.81a6.76 6.76 0 1 1 6.76-6.75a6.77 6.77 0 0 1-6.76 6.75m0-11.51a4.76 4.76 0 1 0 4.76 4.76a4.76 4.76 0 0 0-4.76-4.76"
                                            class="clr-i-outline clr-i-outline-path-1" />
                                        <path fill="#66aee06e"
                                            d="M16.42 31.68A2.14 2.14 0 0 1 15.8 30H4v-5.78a14.8 14.8 0 0 1 11.09-4.68h.72a2.2 2.2 0 0 1 .62-1.85l.12-.11c-.47 0-1-.06-1.46-.06A16.47 16.47 0 0 0 2.2 23.26a1 1 0 0 0-.2.6V30a2 2 0 0 0 2 2h12.7Z"
                                            class="clr-i-outline clr-i-outline-path-2" />
                                        <path fill="#66aee06e" d="M26.87 16.29a.4.4 0 0 1 .15 0a.4.4 0 0 0-.15 0"
                                            class="clr-i-outline clr-i-outline-path-3" />
                                        <path fill="#66aee06e"
                                            d="m33.68 23.32l-2-.61a7.2 7.2 0 0 0-.58-1.41l1-1.86A.38.38 0 0 0 32 19l-1.45-1.45a.36.36 0 0 0-.44-.07l-1.84 1a7 7 0 0 0-1.43-.61l-.61-2a.36.36 0 0 0-.36-.24h-2.05a.36.36 0 0 0-.35.26l-.61 2a7 7 0 0 0-1.44.6l-1.82-1a.35.35 0 0 0-.43.07L17.69 19a.38.38 0 0 0-.06.44l1 1.82a6.8 6.8 0 0 0-.63 1.43l-2 .6a.36.36 0 0 0-.26.35v2.05A.35.35 0 0 0 16 26l2 .61a7 7 0 0 0 .6 1.41l-1 1.91a.36.36 0 0 0 .06.43l1.45 1.45a.38.38 0 0 0 .44.07l1.87-1a7 7 0 0 0 1.4.57l.6 2a.38.38 0 0 0 .35.26h2.05a.37.37 0 0 0 .35-.26l.61-2.05a7 7 0 0 0 1.38-.57l1.89 1a.36.36 0 0 0 .43-.07L32 30.4a.35.35 0 0 0 0-.4l-1-1.88a7 7 0 0 0 .58-1.39l2-.61a.36.36 0 0 0 .26-.35v-2.1a.36.36 0 0 0-.16-.35M24.85 28a3.34 3.34 0 1 1 3.33-3.33A3.34 3.34 0 0 1 24.85 28"
                                            class="clr-i-outline clr-i-outline-path-4" />
                                        <path fill="none" d="M0 0h36v36H0z" />
                                    </svg>
                                </div>
                            </div>

                            <!-- INSURER Card -->
                            <div class="mini-card insurer-card animate-slide-up">
                                <div>
                                    <div class="mini-card-label">{{selectedRole}} AGENTS</div>
                                    <div class="mini-card-count"> {{ totalRolesCount?.[selectedRole.toUpperCase()] || 0 }}
                                    </div>
                                </div>
                                <div class="mini-card-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                                        <path fill="none" stroke="#66aee06e" stroke-linecap="round"
                                            stroke-linejoin="round" stroke-width="1.5"
                                            d="M17.928 19.634h2.138a1.165 1.165 0 0 0 1.116-1.555a6.85 6.85 0 0 0-6.117-3.95m0-2.759a3.664 3.664 0 0 0 3.665-3.664a3.664 3.664 0 0 0-3.665-3.674m-1.04 16.795a1.908 1.908 0 0 0 1.537-3.035a8.03 8.03 0 0 0-6.222-3.196a8.03 8.03 0 0 0-6.222 3.197a1.909 1.909 0 0 0 1.536 3.034zM9.34 11.485a4.16 4.16 0 0 0 4.15-4.161a4.151 4.151 0 0 0-8.302 0a4.16 4.16 0 0 0 4.151 4.16" />
                                    </svg>
                                </div>
                            </div>

                        </div>
                        <!-- Total Admin Insurers Line Chart Card -->
                        <div class="sales-card animate-slide-up no-margin-top">
                            <div class="header">
                                <div class="text-content">
                                    <div class="label fs-13 gray-text">Overall Count
                                    </div>
                                    <div class="total-count">{{ totalInsureres | number }}</div>
                                </div>
                                <div class="icon-container">
                                    <div class="icon-circle">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24">
                                            <g class="user-outline">
                                                <g fill="#fff" fill-rule="evenodd" class="Vector" clip-rule="evenodd">
                                                    <path
                                                        d="M12 10a3 3 0 1 0 0-6a3 3 0 0 0 0 6m0 2a5 5 0 1 0 0-10a5 5 0 0 0 0 10m-7.361 3.448C5.784 13.93 7.509 13 9.714 13h4.572c2.205 0 3.93.93 5.075 2.448C20.482 16.935 21 18.916 21 21a1 1 0 1 1-2 0c0-1.782-.446-3.3-1.235-4.348C17 15.638 15.867 15 14.285 15h-4.57c-1.582 0-2.715.638-3.48 1.652C5.445 17.7 5 19.218 5 21a1 1 0 1 1-2 0c0-2.084.518-4.065 1.639-5.552" />
                                                    <path
                                                        d="M3 21a1 1 0 0 1 1-1h15.962a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1" />
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="chart-container">
                                <canvas #chart baseChart [data]="lineChartData" [options]="lineChartOptions"
                                    [type]="lineChartType"></canvas>
                            </div>
                        </div>
                    </div>
                    <!-- Right 60%: Graph -->
                    <div class="graph-section">

                        @if(selectedRole == enumRole.INSURER || selectedRole == enumRole.DISTRIBUTOR){

                        <ng-container *ngIf="insurerDataLoading; else graphOrNoData">
                            <div class="loader-pro">
                                <app-loader></app-loader>
                            </div>
                        </ng-container>
                        <ng-template #graphOrNoData>
                            <ng-container *ngIf="!emptyInsurerStacks; else noData">
                                <div class="p-4 mt-2">
                                    <canvas baseChart [data]="chartData" [options]="chartOptions" [type]="chartType"
                                        class="chart-canvas"></canvas>
                                </div>
                            </ng-container>
                            <ng-template #noData>
                                <div class="no-data-wrapper animate-slide-up">
                                    <img src="../../../../../assets/images/no-data-found.svg" alt=""
                                        class="no-data-img">
                                    <p class="no-data-text">
                                        No stacks available — this insurer organisation has not started any requests
                                        yet.
                                    </p>
                                </div>
                            </ng-template>
                        </ng-template>
                        }
                        @else if(selectedRole == enumRole.PROVIDER){
                        @if(providerDataLoading){
                        <div class="loader-pro">
                            <app-loader></app-loader>
                        </div>
                        }
                        @else {
                        @if(!emptyProviderStacks){
                        <div class="p-4 mt-2">
                            <canvas baseChart [data]="chartData2" [options]="chartOptions2" [type]="chartType2"
                                class="chart-canvas"></canvas>
                        </div>
                        }
                        @else {
                        <div class="no-data-wrapper animate-slide-up">
                            <img src="../../../../../assets/images/no-data-found.svg" alt="" class="no-data-img">
                            <p class="no-data-text">
                                No stacks available — this provider organisation has not started any requests yet.
                            </p>
                        </div>
                        }
                        }
                        }
                    </div>
                </div>
            </div>
        </section>
    </div>
    }
</div>